function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function sanitizeClassToken(value) {
  return String(value || "")
    .trim()
    .replace(/^\./, "")
    .replace(/\s+/g, "");
}

export function resolveButtonLogMode(hipaaConfig = {}) {
  if (hipaaConfig.button_log_mode) {
    return hipaaConfig.button_log_mode;
  }
  const events = hipaaConfig.events || [];
  if (!events.includes("button_click")) return "none";
  if (sanitizeClassToken(hipaaConfig.tracked_button_class)) return "single";
  return "all";
}

function elementAttrsHaveClass(attrs, classToken) {
  const classMatch = attrs.match(/\bclass\s*=\s*(["'])([\s\S]*?)\1/i);
  if (classMatch) {
    const tokens = classMatch[2].split(/\s+/).filter(Boolean);
    if (tokens.includes(classToken)) return true;
  }

  const quoted = new RegExp(`['"\`]${escapeRegExp(classToken)}['"\`]`);
  return quoted.test(attrs);
}

function templateHasButtonWithClass(template, classToken) {
  if (!template || !classToken) return false;

  const tagRe = /<(button|input)\b([^>]*)>/gi;
  let match;
  while ((match = tagRe.exec(template)) !== null) {
    const tag = match[1].toLowerCase();
    const attrs = match[2] || "";

    if (tag === "input") {
      const typeMatch = attrs.match(/\btype\s*=\s*(["'])([\s\S]*?)\1/i);
      const inputType = typeMatch ? typeMatch[2].toLowerCase() : "submit";
      if (!["button", "submit"].includes(inputType)) continue;
    }

    if (elementAttrsHaveClass(attrs, classToken)) return true;
  }

  return false;
}

export function classExistsOnSiteButton(classToken, components = []) {
  const token = sanitizeClassToken(classToken);
  if (!token) return false;

  return components.some((comp) =>
    templateHasButtonWithClass(comp.template || "", token),
  );
}

/**
 * Returns an error message string when save should be blocked, otherwise null.
 */
export function validateHipaaConfigForSave(hipaaConfig, components = []) {
  if (!hipaaConfig?.enabled) return null;

  const mode = resolveButtonLogMode(hipaaConfig);
  if (mode !== "single") return null;

  const className = sanitizeClassToken(hipaaConfig.tracked_button_class);
  if (!className) {
    return 'Enter a CSS class for the button you want to log, or choose "Log all button clicks".';
  }

  if (!classExistsOnSiteButton(className, components)) {
    return `CSS class "${className}" was not found on any button in this site's components. Add class="${className}" to the target button, then save again.`;
  }

  return null;
}
